// PRE-4896 : organisations affiliées EUODIA. La slide "Taux par support" du funnel de souscription
// leur est affichée en lecture seule (les consultants de ces organisations ne peuvent pas modifier
// eux-mêmes les taux : toute erreur constatée doit être remontée à l'équipe d'administration produit).
//
// Dupliqué côté front faute de mécanisme existant pour exposer un indicateur d'affiliation via l'API
// (cf. spec PRE-4896) — DOIT rester synchronisé avec
// `OrganizationConstants.EUODIA_AFFILIATED_ORGANIZATION_IDS` côté domains
// (domain-base/base-dto/.../organization/OrganizationConstants.java).
export const EUODIA_AFFILIATED_ORGANIZATION_IDS: number[] = [
  1, // EUODIA_ORGANISATION_ID
  56152307, // ARTEMIS_ORGANISATION_ID
  81880473, // FORTUNY_ORGANISATION_ID
  1286361108, // PICK6_ORGANISATION_ID
  251251251, // CRISTALIS_ORGANISATION_ID
  6135807591, // CIPSE_ORGANIZATION_ID
];

/**
 * PRE-4906 : une vente est "via AlbR" (par opposition à "en direct") dès lors que l'organisation du
 * consultant est affiliée EUODIA (structurellement incapable de vente en direct), OU qu'au moins un
 * produit du pledge n'est pas en vente directe (`directSale` non vrai). La slide "Taux par support"
 * ne s'affiche normalement que pour un pledge mono-produit, mais par sécurité un seul produit via
 * AlbR suffit à rendre toute la slide lecture seule.
 *
 * Même logique que côté back (`SupportRateResolutionService.isDirectSale`, cf. spec PRE-4906) —
 * aucune surcharge cabinet (`PrProductSupportOrganization`) n'est jamais utilisée dans ce cas, d'où
 * l'alignement du comportement front (lecture seule = rien à saisir).
 */
export function isSaleViaAlbR(
  organizationId: number | null | undefined,
  products: { directSale?: boolean }[] | null | undefined,
): boolean {
  const isEuodiaAffiliatedOrganization =
    organizationId != null && EUODIA_AFFILIATED_ORGANIZATION_IDS.includes(organizationId);
  return (
    isEuodiaAffiliatedOrganization ||
    (products ?? []).some(product => product.directSale !== true)
  );
}
